<template>
   <tr v-wo-mark-table-row>
     <slot>
       <th v-for="(header, index) in headers" :key="index" :colspan="header.span || 1" :width="header.width" :class="header.classes">
         <wo-label>{{ header.name }}</wo-label>
       </th>
     </slot>
   </tr>
</template>
<script>

import _ from 'lodash'

export default {
  name: 'PoTableHeader',
  props: {
    columns: Array,
    align: String
  },
  computed: {
    headers () {
      return _.map(this.columns, this.createColumn)
    }
  },
  methods: {
    createColumn (definition) {
      const result = Object.assign({
        name: definition.labelKey ? this.$t(definition.labelKey) : definition.name,
        classes: []
      }, definition)

      if (definition.align) {
        result.classes.push(`po-align-${definition.align}`)
      }

      if (definition.mark) {
        result.classes.push('wo-data-table__marked-cell')
      }
      return result
    }
  }
}
</script>
<style lang="scss">
  .wo-data-table th.po-align-right {
    text-align: right;
  }
</style>
